// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__MLXmc","spin":"styles_spin__Sr4Jk"};